import { useQuery } from "@tanstack/react-query";
import { ATTRAPPE, hole } from "./klient";
import { alsFruehereMengen, alsMengenvorschlag } from "./mengenvorschlag";

export type { Mengenvorschlag } from "./mengenvorschlag";

/* ══════════════════════════════════════════════════════════════════
   Die Menge vom letzten Mal — für eine Leistung in der Merkliste
   (08.10.2026).

   Luca: *„Guck, ob es das letzte Mal schon mal gab, das vorschlagen, aber
   man kann das auch ohne Ort vermieten."* Gefragt wird `GET
   /merkliste/zuletzt` mit Kunde, Leistungsart und Einsatzort; die API wählt
   (Ist vor Plan, derselbe Ort zuerst, dann die jüngste). Hier wird nur
   angeglichen — und **nichts eingetragen**: Der Vorschlag steht als leiser
   Verweis am Feld und wird erst auf Klick übernommen (Regel 11).

   Eine eigene Datei wie `preisbuendel.ts`: eigener Weg, eigene Form.
   ══════════════════════════════════════════════════════════════════ */

type Roh = Record<string, unknown>;

/**
 * Der Vorschlag für eine Leistung — nur, wenn ein Kunde gewählt ist. Ohne
 * Kunden gibt es kein „letztes Mal", und ohne Leistungsart (Zeile von Hand)
 * keine Leistung, nach der man fragen könnte.
 */
export function useLetzteMenge(frage: { kunde: string; leistungsart: string; ort: string }, an = true) {
  const bereit = an && !ATTRAPPE && Boolean(frage.kunde) && Boolean(frage.leistungsart);
  return useQuery({
    queryKey: ["letzteMenge", frage.kunde, frage.leistungsart, frage.ort],
    enabled: bereit,
    staleTime: 60_000,
    queryFn: async () => {
      const teile = new URLSearchParams({ kunde: frage.kunde, leistungsart: frage.leistungsart });
      if (frage.ort) teile.set("ort", frage.ort);
      const roh = await hole<Roh>(`/merkliste/zuletzt?${teile.toString()}`);
      /* Der Vorschlag und, seit Paket aufnahmen2, die früheren Werte. */
      return { vorschlag: alsMengenvorschlag(roh), frueher: alsFruehereMengen(roh) };
    },
  });
}
